export default __webpack_public_path__ + "static/media/Schwee.8d7032da.png";